import { Skeleton, Tabs, Typography } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { SYSTEM_USER_ID } from '@app/constants';
import { PREFIX } from '@app/constants/appPrefix';
import { useUsersAccessRights } from '@app/hooks';
import { shortName } from '@app/utils';

import { useEditEmployee } from '@pages/Employees/EditEmployee/hooks/useEditEmployee';

import { TabsData } from '@pages/Employees/EditEmployee/data/TabsData';

import type { FC } from 'react';

import '@pages/Employees/EditEmployee/styles/EditEmployee.desktop.scss';
import '@pages/Employees/EditEmployee/styles/EditEmployee.tablet.scss';

const { Title, Text } = Typography;

export const EditEmployee: FC = () => {
  const {
    isDesktop,
    contextHolder,
    isGlobalLoader,
    employee,
    activeKey,
    infoData,
    setInfoData,
    setNewData,
    newData,
    handleTabClick,
    allServices,
    setAllServices,
    allSettings,
    setEmployee,
    hasUserRightToViewAccessRightTab,
    isNeedToUpdateUserPreview,
    setIsNeedToUpdateUserPreview,
    hasUserRightToAttachServices,
    editableUserAccessRights,
    editableUserUnsavedAccessRights,
    setEditableUserUnsavedAccessRights,
    isGetUserAccessRightsLoading,
    setEditableUserAccessRights,
    hasCurrentUserRightToViewAllRecords,
    getEmployeeData,
    servicesLoadState,
    setHandleUnsavedChanges,
  } = useEditEmployee();

  const { hasUserRightToEdit, hasRightToModuleView } = useUsersAccessRights();

  const isSystemUser = employee?.id ? employee.id === SYSTEM_USER_ID : true;

  if (isGlobalLoader) return <Skeleton active />;

  if (isSystemUser) return <Error403Unauthorized />;

  return (
    <div className={`${PREFIX}edit-employee ${PREFIX}global-tab-styles`}>
      {contextHolder}
      {employee && hasRightToModuleView ? (
        <>
          <div
            className="ant-tabs-nav"
            style={{ padding: '0', marginBottom: '20px' }}
          >
            <Title level={4} className="mg-0" data-testid="employee-block">
              Исполнитель
            </Title>
            <Text strong data-testid="employee-full-name">
              {shortName(
                `${employee?.nameLast || ''} ${employee.nameFirst}`.trim(),
                !isDesktop,
                23
              )}
            </Text>
          </div>
          <Tabs
            className={`${PREFIX}employees-tabs`}
            type={isDesktop ? 'line' : 'card'}
            tabPosition={isDesktop ? 'left' : 'top'}
            destroyOnHidden
            items={TabsData({
              employee,
              infoData,
              setInfoData,
              setNewData,
              newData,
              allServices,
              setAllServices,
              hasUserRightToEdit,
              allSettings,
              setEmployee,
              hasUserRightToViewAccessRightTab,
              isNeedToUpdateUserPreview,
              setIsNeedToUpdateUserPreview,
              hasUserRightToAttachServices,
              editableUserAccessRights,
              editableUserUnsavedAccessRights,
              setEditableUserUnsavedAccessRights,
              isGetUserAccessRightsLoading,
              setEditableUserAccessRights,
              hasCurrentUserRightToViewAllRecords,
              getEmployeeData,
              servicesLoadState,
              setHandleUnsavedChanges,
            })}
            onTabClick={(key) => handleTabClick(key)}
            activeKey={activeKey}
          />
        </>
      ) : (
        <Error403Unauthorized />
      )}
    </div>
  );
};
